import moment from 'moment/moment';
import React from 'react';
import { Link } from 'react-router-dom';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import CloudinaryAdvancedImage from '@common/utils/CloudinaryAdvancedImage';
import { processJSXContent } from '@common/utils/blogHyperlinks';


function InfoTile({ title, subTitle, time, description, mediaUrl, articleUrl, variant, croppedMediaUrl }) {

  const updatedDate = moment(time).format('MMMM Do YYYY, h:mm:ss A');

  // console.log('articleUrl', articleUrl)

  return (
    <div className={`bs-info-tile ${(variant === 'electronic' || variant === 'blog') ? 'bs-info-tile--typ-article' : ''}  ${variant === "press" ? 'bs-info-tile--typ-press' : ''}`}>
      {/* {variant !== "press" &&  */}
      <Link to={articleUrl} target="_blank" className='bs-info-tile__link'>Link</Link>
      {/* // } */}
      {mediaUrl ? (
        <div className='bs-info-tile__image-wrap'>
          {mediaUrl.startsWith('/') ? (
            <img src={mediaUrl} alt={title} className='bs-info-tile__image' style={{ objectFit: 'cover', width: '100%', height: '100%' }} />
          ) : (
            variant === "press" ? (
              <>
                {/* <Zoom zoomImg={articleUrl}> */}
                <CloudinaryAdvancedImage imagePublicId={croppedMediaUrl} className='bs-info-tile__image' type="section-feature-image" />
                {/* </Zoom> */}
              </>
            ) : (<>
              <CloudinaryAdvancedImage imagePublicId={mediaUrl} className='bs-info-tile__image' type="section-feature-image" />
            </>)
          )}

        </div>
      ) : null}
      <div className='bs-info-tile__info-wrap'>
        {subTitle && <strong className='bs-info-tile__sub-title'>{subTitle}</strong>}
        {title && <h3 className='bs-info-tile__title'>{title}</h3>}
        {time && <label className='bs-info-tile__time'>{updatedDate}</label>}
        {description && <p className='bs-info-tile__desc' dangerouslySetInnerHTML={processJSXContent(description)} />}
      </div>
    </div>
  )
}

export default InfoTile